import actions from "../actionTypes/filterTypes";

export const getCandidateSelectedClient = payload => ({
  type: actions.CANDIDATE_SELECTED_CLIENT,
  payload
});

export const getCandidateSelectedSite = payload => ({
  type: actions.CANDIDATE_SELECTED_SITE,
  payload
});

export const getCandidateSelectedStatus = payload => ({
  type: actions.CANDIDATE_SELECTED_STATUS,
  payload
});

export const getSiteSelectedStatus = payload => ({
  type: actions.SITE_SELECTED_STATUS,
  payload
});

export const getCandidateStatus = payload => ({
  type: actions.CANDIDATE_STATUS,
  payload
});

export const getSelectedDate = payload => ({
  type: actions.SELECTED_DATE,
  payload
});

export const getCandidateSearchKeyword = payload => ({
  type: actions.CANDIDATE_SEARCH_KEYWORD,
  payload
});

export const getCandidatesSelected = payload => ({
  type: actions.CANDIDATE_SELECTED,
  payload
});

export const getCandidateSelectedBranches = payload => ({
  type: actions.CANDIDATE_SELECTED_BRANCHES,
  payload
});

export const getCandidateSelectedTags = payload => ({
  type: actions.CANDIDATE_SELECTED_TAGS,
  payload
});

export const getAssignCandidateSelectedBranches = payload => ({
  type: actions.ASSIGN_CANDIDATE_SELECTED_BRANCHES,
  payload
});

export const getAssignCandidateSelectedTags = payload => ({
  type: actions.ASSIGN_CANDIDATE_SELECTED_TAGS,
  payload
});

export const clearSelectedClient = () => ({
  type: actions.CANDIDATE_SELECTED_CLIENT_CLEAR
});

export const getBookingSearchCandidate = payload => ({
  type: actions.CANDIDATE_DAILY_BOOKING_FILTER,
  payload
});

export const clearBookingSearchCandidate = () => ({
  type: actions.CANDIDATE_DAILY_BOOKING_CLEAR
});

export const getVerifyBookingCandidate = payload => ({
  type: actions.CANDIDATE_VERIFY_BOOKING_FILTER,
  payload
});

export const clearVerifyBookingCandidate = () => ({
  type: actions.CANDIDATE_VERIFY_BOOKING_CLEAR
});

export const getWeeklyBookingFilter = payload => ({
  type: actions.WEEKLY_BOOKING_FILTER,
  payload
});

export const clearWeeklyBookingFilter = () => ({
  type: actions.WEEKLY_BOOKING_FILTER_CLEAR
});

export const getMonthlyBookingFilter = payload => ({
  type: actions.MONTHLY_BOOKING_FILTER,
  payload
});


export const clearMonthlyBookingFilter = () => ({
  type: actions.MONTHLY_BOOKING_FILTER_CLEAR
});

export const getCandidateSelectedShifts = payload => ({
  type: actions.CANDIDATE_SELECTED_SHIFTS,
  payload
});

export const setPayRateFilters = payload => ({
  type: actions.PAY_RATE_FILTER,
  payload
});

export const clearPayRateFilters = () => ({
  type: actions.PAY_RATE_FILTER_CLEAR
});